import * as React from 'react';
export const labSvg = React.forwardRef(function labSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 12.64a2 2 0 0 1 .373-1.162L5.5 5.7V1.5h-.255a.75.75 0 1 1 0-1.5h5.505a.75.75 0 0 1 0 1.5h-.25v4.2l4.127 5.779A2 2 0 0 1 15 12.64V13a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-.36ZM9 1.5H7v4.2a1.5 1.5 0 0 1-.28.872L5.7 8h2.18a.625.625 0 1 1 0 1.25H4.808L3.558 11H7.38a.625.625 0 1 1 0 1.25H2.665l-.072.1a.5.5 0 0 0-.093.29V13A1.5 1.5 0 0 0 4 14.5h8a1.5 1.5 0 0 0 1.5-1.5v-.36a.5.5 0 0 0-.093-.29L9.279 6.572A1.5 1.5 0 0 1 9 5.7V1.5Z',
    }),
  );
});
labSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lab = {
  category: 'icon',
  colorable: true,
  name: 'lab',
  svg: labSvg,
};
